
import React from 'react';
import { useParams } from 'react-router-dom'; // Hook to get URL parameters
import SpeedTestChart from '../components/SpeedTestChart';

const SpeedTestPage = () => {
  const { androidId } = useParams(); // Get the androidId from the URL

  return (
    <div className="p-4 sm:p-8 md:p-10">
      <h1 className="text-3xl font-semibold mb-6 text-center">
        Speed Test Chart of : <span className="font-mono">{androidId}</span>
      </h1>
      <SpeedTestChart androidId={androidId} />
    </div>
  );
};

export default SpeedTestPage;
